import { motion } from "framer-motion";

const shots = [
  { src: "/shop/gmaps-1.jpg", label: "RGB Setup", meta: "01" },
  { src: "/shop/gmaps-2.jpg", label: "Neon Vibes", meta: "02" },
  { src: "/shop/gmaps-3.jpg", label: "Late Night", meta: "03" },
  { src: "/shop/gmaps-4.jpg", label: "For every gamer", meta: "04" },
  { src: "/shop/cafe-buondi.jpg", label: "Café Buondi", meta: "05" },
];

export const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A] border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-sky-400" />
              <span className="font-mono text-[11px] tracking-[0.3em] text-sky-400 uppercase">
                Inside the spot
              </span>
            </div>
            <h2 className="font-display text-white text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.95]">
              Μια ματια <span className="text-sky-400">στον χωρο.</span>
            </h2>
          </div>
          <p className="max-w-md text-zinc-400 text-sm md:text-base leading-relaxed">
            RGB φώτα, gaming chairs, high-end setups και μια κοινότητα που δεν σταματάει
            ποτέ να παίζει. Έλα να το δεις από κοντά.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {shots.map((s, i) => (
            <motion.div
              key={s.src}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group relative aspect-square overflow-hidden border border-zinc-800 hover:border-sky-400/60 transition-colors shot-wrap"
              data-testid={`gallery-shot-${i}`}
            >
              <img
                src={s.src}
                alt={s.label}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 shot-enhance"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
              <div className="absolute inset-0 p-4 flex flex-col justify-between">
                <span className="font-mono text-[10px] tracking-[0.3em] text-sky-400 uppercase">
                  {s.meta}
                </span>
                <div className="font-display text-white text-lg md:text-xl uppercase leading-tight">
                  {s.label}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
